import React from "react"
import { LINKS } from "@constants"
import { useLinksContainerConfiguration } from "../../../../hooks"
import {
  StyledLinkContainer,
  StyledFirstLinksSection,
  StyledSectionTitle,
  StyledSecondaryLinksContainer,
  StyledSecondLinksSection,
  StyledFourthLinksSection,
  StyledMainLinksContainer,
} from "./styled"
import { ReactSVG } from "react-svg"
import RightArrow from "@images/common/right-arrow-solid.svg"

const LinksContainer = ({ setShowLinks, path }) => {
  const {
    isWindowDefined,
    isDesktop,
    thirdLinksContainerMarkup,
    generateLinks,
  } = useLinksContainerConfiguration(path, setShowLinks)

  return (
    <StyledLinkContainer>
      <StyledFirstLinksSection isWindowDefined={isWindowDefined}>
        <StyledMainLinksContainer>
          <StyledSectionTitle>Services</StyledSectionTitle>
          {isDesktop ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              {generateLinks(
                LINKS.services,
                true,
                path,
                setShowLinks,
                <ReactSVG src={RightArrow} />
              )}
            </div>
          ) : (
            <>{generateLinks(LINKS.services, true, path, setShowLinks)}</>
          )}
        </StyledMainLinksContainer>
        {!isDesktop && thirdLinksContainerMarkup}
      </StyledFirstLinksSection>

      <StyledSecondaryLinksContainer isWindowDefined={isWindowDefined}>
        <StyledSecondLinksSection>
          <StyledSectionTitle>Expertise</StyledSectionTitle>
          {generateLinks(LINKS.expertise, false, path, setShowLinks)}
        </StyledSecondLinksSection>

        {isDesktop && thirdLinksContainerMarkup}
        <StyledFourthLinksSection>
          <StyledSectionTitle>Industry</StyledSectionTitle>
          {generateLinks(LINKS.industry, false, path, setShowLinks)}
        </StyledFourthLinksSection>
      </StyledSecondaryLinksContainer>
    </StyledLinkContainer>
  )
}

export default LinksContainer
